export default __webpack_public_path__ + "static/media/user-profile.a90d6504.svg";